/* eslint-disable */
import {execute, grable} from '../concrete'

const concreteModuleName = 'concrete'

const SwProjectService = {
    /**
     * 上传文件
     * @param {*} fileName 
     * @param {*} base64 
     * @returns Promise 
     */
    'uploadFile': function (fileName, base64) {
        return  grable(concreteModuleName)
            ? execute(concreteModuleName, 'b8b8de95f9544cf43e7c45844232630b34785382', {fileName, base64})
            : execute(concreteModuleName, `/SwProjectService/uploadFile`, 'text', 'POST', { fileName, base64 });
    }, 
    /**
     * 项目指派（编辑）
     * @param {*} assignData 
     * @returns Promise 
     */
    'updateProjectAssign': function (assignData) {
        return  grable(concreteModuleName)
            ? execute(concreteModuleName, 'b852a52260dc44efbd9ecd3a6338d6d4d3f49fa7', assignData)
            : execute(concreteModuleName, `/SwProjectService/projectAssign`, 'json', 'PUT', assignData);
    }, 
    /**
     * 参与单位
     * @param {*} projectId 项目id
     * @returns Promise 
     */
    'listParticipatingUnit': function (projectId) {
        return  grable(concreteModuleName)
            ? execute(concreteModuleName, '98ebc6967e551a16fdd622d83cd8a04973e6a987', projectId)
            : execute(concreteModuleName, `/SwProjectService/listParticipatingUnit`, 'json', 'POST', { projectId });
    }, 
    /**
     * 根据项目id查询项目中心点经纬度
     * @param {*} id 
     * @returns Promise 
     */
    'plotsLatLngList': function (id) {
        return  grable(concreteModuleName)
            ? execute(concreteModuleName, '0f806bd42a19ef577a61931cb1c4d5e9ba964f64', id)
            : execute(concreteModuleName, `/SwProjectService/plotsLatLngList`, 'json', 'POST', { id });
    }, 
    /**
     * 进展记录
     * @param {*} projectId 项目id
     * @returns Promise 
     */
    'listProgressRecord': function (projectId) {
        return  grable(concreteModuleName)
            ? execute(concreteModuleName, 'b09be8e7db14d0d336125a070def19f0c4b34fa3', projectId)
            : execute(concreteModuleName, `/SwProjectService/listProgressRecord`, 'json', 'POST', { projectId });
    }, 
    /**
     * 根据项目id查询项目地块边框
     * @param {*} projectBorderPo 
     * @returns Promise 
     */
    'plotsBorderList': function (projectBorderPo) {
        return  grable(concreteModuleName)
            ? execute(concreteModuleName, '684996432f9956aff9369cda0814459130fbe9a8', projectBorderPo)
            : execute(concreteModuleName, `/SwProjectService/plotsBorderList`, 'json', 'POST', projectBorderPo);
    }, 
    /**
     * 添加主项目
     * @param {*} addData 
     * @returns Promise 
     */
    'addProject': function (addData) {
        return  grable(concreteModuleName)
            ? execute(concreteModuleName, '6f44d415ca0a7b892b70e436b8e9873b5827f6fa', addData)
            : execute(concreteModuleName, `/SwProjectService/addProject`, 'json', 'POST', addData);
    }, 
    /**
     * 项目编辑
     * @param {*} updateData 
     * @returns Promise 
     */
    'updateProject': function (updateData) {
        return  grable(concreteModuleName)
            ? execute(concreteModuleName, '290c2b28cf5dc6100cadec4b1b1110ad99b2d00a', updateData)
            : execute(concreteModuleName, `/SwProjectService/project`, 'json', 'PUT', updateData);
    }, 
    /**
     * 项目进度
     * @param {*} projectId 项目id
     * @returns Promise 
     */
    'projectSchedule': function (projectId) {
        return  grable(concreteModuleName)
            ? execute(concreteModuleName, '2fd34999bb3ae8d64cbbce2256c925bfc7f1f1e0', projectId)
            : execute(concreteModuleName, `/SwProjectService/projectSchedule`, 'json', 'POST', { projectId });
    }, 
    /**
     * 添加参与者
     * @param {*} addData 
     * @returns Promise 
     */
    'addParticipant': function (addData) {
        return  grable(concreteModuleName)
            ? execute(concreteModuleName, '466ff81ad7dd0cc60a47154d7af0b57192b928f5', addData)
            : execute(concreteModuleName, `/SwProjectService/addParticipant`, 'json', 'POST', addData);
    }, 
    /**
     * 根据Id删除项目信息
     * @param {*} id 项目id
     * @returns Promise 
     */
    'deleteSwProject': function (id) {
        return  grable(concreteModuleName)
            ? execute(concreteModuleName, '3fc90e35cd479410d4bb366a88799d3af6ae84fe', id)
            : execute(concreteModuleName, `/SwProjectService/swProject`, 'json', 'DELETE', { id });
    }, 
    /**
     * 项目汇报
     * @param {*} addData 
     * @returns Promise 
     */
    'addProjectReport': function (addData) {
        return  grable(concreteModuleName)
            ? execute(concreteModuleName, 'cb183d81ddc586462b54b82135dd18fbf22376df', addData)
            : execute(concreteModuleName, `/SwProjectService/addProjectReport`, 'json', 'POST', addData);
    }, 
    /**
     * 项目详情
     * @param {*} id 
     * @returns Promise 
     */
    'detailProject': function (id) {
        return  grable(concreteModuleName)
            ? execute(concreteModuleName, '969d087191b0e15f455a84dd014f2706362c7a17', id)
            : execute(concreteModuleName, `/SwProjectService/detailProject`, 'json', 'POST', { id });
    }, 
    /**
     * 项目详情（回显用）
     * @param {*} projectId 
     * @returns Promise 
     */
    'detail': function (projectId) {
        return  grable(concreteModuleName)
            ? execute(concreteModuleName, 'c74dc9a986d96608287e3f9d1ecfa71099bf1792', projectId)
            : execute(concreteModuleName, `/SwProjectService/detail`, 'json', 'POST', { projectId });
    }, 
    /**
     * 查询地块边框
     * @param {*} data 
     * @returns Promise 
     */
    'detailOperationInfo': function (data) {
        return  grable(concreteModuleName)
            ? execute(concreteModuleName, '5d6477c1f2e389cef27fbf65b2f1a8be7f35ad77', data)
            : execute(concreteModuleName, `/SwProjectService/detailOperationInfo`, 'json', 'POST', data);
    }, 
    /**
     * 根据id获取项目地块边框经纬度
     * @param {*} projectManagementBorderPo 
     * @returns Promise 
     */
    'projectBorderList': function (projectManagementBorderPo) {
        return  grable(concreteModuleName)
            ? execute(concreteModuleName, 'c995adb1b790dfaade1f9d5edc5b1eb8ff9856e1', projectManagementBorderPo)
            : execute(concreteModuleName, `/SwProjectService/projectBorderList`, 'json', 'POST', projectManagementBorderPo);
    }, 
    /**
     * 项目概览列表
     * @param {*} year 
     * @param {*} page 
     * @param {*} size 
     * @returns Promise 
     */
    'listProjectOverview': function (year, page, size) {
        return  grable(concreteModuleName)
            ? execute(concreteModuleName, '58eb88f397df624abf4c0eaf0f3dc12f532a9367', {year, page, size})
            : execute(concreteModuleName, `/SwProjectService/listProjectOverview`, 'json', 'POST', { year, page, size });
    }, 
    /**
     * 获取下级单位
     * @returns Promise 
     */
    'listLower': function () {
        return  grable(concreteModuleName)
            ? execute(concreteModuleName, '6ddf25fba3769396130cf7c8e0c6c1494d11e5f7')
            : execute(concreteModuleName, `/SwProjectService/listLower`, 'json', 'GET');
    }, 
    /**
     * 根据id获取项目地块中心点经纬度
     * @param {*} swUnitPrimaryId 
     * @returns Promise 
     */
    'projectLocusList': function (swUnitPrimaryId) {
        return  grable(concreteModuleName)
            ? execute(concreteModuleName, '00b117e50d9f05a74b6417ca217c3afe11919151', swUnitPrimaryId)
            : execute(concreteModuleName, `/SwProjectService/projectLocusList`, 'json', 'POST', { swUnitPrimaryId });
    }
}

export default SwProjectService
